module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_rec_1.f164b192.png";